import React, { useState, useContext } from 'react';
import { ReactComponent as Menu } from 'assets/svg/menu.svg';
import { ReactComponent as ShoppingBag } from 'assets/svg/shopping-bag.svg';
import { ReactComponent as Bell } from 'assets/svg/bell.svg';
import { ReactComponent as Back } from 'assets/svg/back.svg';
import { Button, Badge } from 'antd';
import { Link } from 'react-router-dom';
import { ConfigContext } from 'store/context';
import { SidebarCollapse } from 'store/actions/ConfigAction';
import classNames from 'classnames';
import NotiDrawer from './NotiDrawer';

function AppHeader(props) {
  const { ConfigDispatch } = useContext(ConfigContext);
  const [visible, setVisible] = useState(false);
  const Classes = classNames({
    'flex justify-between items-start omi-header': true,
    'omi-header-menu-collapsed': props.status,
  });
  return (
    <div className={Classes}>
      <div className="flex">
        <div className="omi-button-collapse-menu">
          <Menu onClick={() => ConfigDispatch(SidebarCollapse())} />
        </div>
        {props.redirect && (
          <div className="hidden lg:block">
            <Link to={props.redirect.link} className="omi-back-to-link text-grey-800 hover:text-grey-800">
              <Back className="inline-block mr-4" />
              <span className="align-middle font-semibold text-md">{props.redirect.name}</span>
            </Link>
          </div>
        )}
      </div>
      <div className="flex h-8 omi-header-action">
        <Button type="primary" size="small" className="rounded-omi-8 b-shipping-bag leading-0" href="/pos">
          <ShoppingBag className="inline-block" />
          Điểm bán hàng
        </Button>
        <Badge count={0}>
          <Button type="primary" onClick={() => setVisible(true)} className="rounded-omi-8 alarm">
            <Bell className="inline-block" />
          </Button>
        </Badge>
      </div>
      <NotiDrawer visible={visible} onClose={() => setVisible(false)} />
    </div>
  );
}
export default AppHeader;
